<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contatti</li>
            </ul>
            <h2>Contattaci</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div id="map">
    <iframe src="https://maps.google.com/maps?q=auge Via Polesine, 20 00128 – Roma%20Italia&t=k&z=19&ie=UTF8&iwloc=&output=embed"></iframe>
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Chi siamo</span>
                    <h2>Siamo un ateneo in collaborazione internazionale che eroga titoli di studio equipollenti a quelli delle università tradizionali.</h2>
                    <p>
                        Ente di alta formazione Universitaria internazionale privato regolato da statuto per sviluppare gli studi in varie branche del sapere che opera in conformità agli standard di cui all’art. 6 del Dlgs 16 gennaio 2013, per l'erogazione di Titoli nel comparato dell'Alta Formazione per Qualifica Professionale - Diploma Accademico di I Livello in conformità agli standard legalmente riconosciuto in Italia anche in rispetto della normativa Europea acquisita.
                    </p>
                    <p>
                      Commissione Europea "EDUCATION AND TRAINING" Quadro Europeo delle Qualifiche nel rispetto del Regolamento UE 2019/128 del Parlamento Europeo e del consiglio del 16 gennaio 2019, autorizzazione CEDEFEOP programma 2025/2027 che opera anche in collaborazione con enti universitari internazionali e centri di cultura internazionali, per affiliazione culturale scientifica come Università diversamente riconosciuta secondo quanto previsto dalla convenzione di Lisbona (Università non facente parte dell’ordinamento italiano in quanto Università di diritto internazionale) pubblicato in Gazzetta Ufficiale.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">dalla formazione alla professione</span>
                    <h2>Attività di formazione</h2>
                    <p>
                        I corsi di formazione sono finalizzati rispettivamente alla preparazione e formazione costante del Professionista. L’elevato livello della Scuola è confermato dal corpo docenti, costituito da Professori ordinari di ruolo, Consiglieri di Stato, Magistrati ordinari e amministrativi, e dal contenuto dei programmi strutturato in modo tale da affrontare in maniera sistematica ed organica le principali tematiche inerenti ai concorsi.
                    </p>
                    <p>
                        In particolare, è prevista una serie di lezioni frontali, completate da continue prove pratiche, che hanno lo scopo di preparare adeguatamente i discenti in vista del superamento del concorso. Le lezioni frontali sono sempre accompagnate da materiale didattico fornito di volta in volta dai docenti.
                    </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <ul>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>AUGE UNIVERSITA’</h3>
                            <p>Via Polesine, 20<br>00128 Roma</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti</h3>
                            <p>Mobile: <a href="tel:+390692939204">(+39) 06-92939204 </a></p>
                            <p><a href="mailto:info@augeuniversita.it">info@augeuniversita.it</a></p>
                        </li>
                        <li class="d-none">
                            <div class="icon">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <h3>Siamo disponibili</h3>
                            <p>Lunedì - Venerdì: 09:00 - 18:00</p>
                            <p>Sabato: 09:00 - 13:00</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
                    <h2>Come possiamo aiutarti?</h2>
                    <p>L'indirizzo email non verrà pubblicato. i campi richiesti sono contrassegnati dal simbolo*</p>
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Nome e Cognome">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Nome e Cognome richiesto.</div>
                                        <div *ngIf="name.errors.minlength">Numero minimo {{ name.errors.minlength.requiredLength }} di caratteri.</div>
                                        <div *ngIf="name.errors.maxlength">Numero massimo di 50 caratteri.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="la tua e-mail">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="cellulare">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">un contatto telefonico è obbligatorio</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5" class="form-control" placeholder="scrivi il tuo messaggio..."></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">il messaggio è obbligatorio</div>
                                </div>
                            </div>
                            <h2 class="mt-3">Quale corso sei interessato?</h2>
                            <p>seleziona il corso interessato alla quale vuoi avere informazioni*</p>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <select name="sceltaCorso" ngModel id="sceltaCorso" #sceltaCorso="ngModel" style="display: block;
                                    width: 100%;
                                    border: none;
                                    color: var(--blackColor);
                                    background-color: #F3F6F9;
                                    height: 50px;
                                    padding-left: 15px;
                                    border-radius: 5px;
                                    font-size: var(--fontSize);
                                    font-weight: 600">
                                        <option value="{{elencoCorsiRow['corso']['titolo']}}" *ngFor="let elencoCorsiRow of elencoCorsi">{{elencoCorsiRow['corso']['titolo']}}</option>
                                      </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 mt-3">
                                <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid">Invia Richiesta<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
